import { Breadcrumbs, Loader } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import type { FC } from 'react';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import { AccountSetting } from '~/components/specifics/vendors/settings/accounts/AccountSetting';
import { PATH } from '~/pages/vendors/settings';
import SettingStyles from '../SettingStyle.module.scss';
import { useSessions } from '~/hooks/vendors/useSessions';

export const Page: FC = () => {
  const { data: session } = useSessions().index();

  if (session === null) {
    return <Loader />;
  }

  return (
    <VendorLayoutV2>
      <VendorSettingLayout>
        <div className={SettingStyles.SpBreadcrumbsWrapper}>
          <Breadcrumbs
            items={[
              { label: '設定一覧', as: Link, href: PATH },
              { label: 'アカウント詳細' }
            ]}
          />
        </div>
        <AccountSetting session={session} />
      </VendorSettingLayout>
    </VendorLayoutV2>
  );
};
